import React, { useEffect, useState } from "react";
import "../../assets/css/styles.css";
import "../../assets/libs/bootstrap/css/bootstrap.min.css";

const Faqcardsupport = ({ activeTab }) => {
  const [activeAccordion, setActiveAccordion] = useState(null);

  const toggleAccordion = (accordionId) => {
    setActiveAccordion((prev) => (prev === accordionId ? null : accordionId));
  };

  const [languageData, setLanguageData] = useState(null);

  useEffect(() => {
    const defaultLang = process.env.REACT_APP_LANG;
    const cookieLang =
      localStorage.getItem("lang") ||
      document.cookie
        .split("; ")
        .find((row) => row.startsWith("lang="))
        ?.split("=")[1] ||
      defaultLang;
    if (cookieLang) {
      import(`../../lang/faq/${cookieLang}.json`)
        .then((data) => {
          setLanguageData(data);
        })
        .catch((error) => {
          console.error("Error loading language file:", error);
        });
    } else {
      console.warn("Language cookie 'lang' not found.");
    }
  }, []);

  if (!languageData) {
    return <div></div>;
  }

  const generalFAQs = [
    {
      id: "item1",
      question: languageData.general[0].title,
      answer: languageData.general[0].content,
    },
    {
      id: "item2",
      question: languageData.general[1].title,
      answer: languageData.general[1].content,
    },
    {
      id: "item3",
      question: languageData.general[2].title,
      answer: languageData.general[2].content, // Now an array
    },
    {
      id: "item4",
      question: languageData.general[3].title,
      answer: languageData.general[3].content, // Now an array
    },
    {
      id: "item5",
      question: languageData.general[4].title,
      answer: languageData.general[4].content, // Now an array
    },
    {
      id: "item6",
      question: languageData.general[5].title,
      answer: languageData.general[5].content, // Now an array
    },
    {
      id: "item7",
      question: languageData.general[6].title,
      answer: languageData.general[6].content, // Now an array
    },
    {
      id: "item8",
      question: languageData.general[7].title,
      answer: languageData.general[7].content, // Now an array
    },
    {
      id: "item9",
      question: languageData.general[8].title,
      answer: languageData.general[8].content, // Now an array
    },
    {
      id: "item10",
      question: languageData.general[9].title,
      answer: languageData.general[9].content, // Now an array
    },
    {
      id: "item11",
      question: languageData.general[10].title,
      answer: languageData.general[10].content, // Now an array
    },
  ];

  const supportFAQs = [
    {
      id: "item1",
      question: languageData.support[0].title,
      answer: languageData.support[0].content,
    },
    {
      id: "item2",
      question: languageData.support[1].title,
      answer: languageData.support[1].content,
    },
    {
      id: "item3",
      question: languageData.support[2].title,
      answer: languageData.support[2].content,
    },
    {
      id: "item4",
      question: languageData.support[3].title,
      answer: languageData.support[3].content,
    },
  ];

  const renderAccordion = (faqItems, parentId) => (
    <div
      className="accordion accordion-customicon1 accordion-primary"
      id={parentId}
    >
      {faqItems.map((item) => (
        <div className="accordion-item" key={item.id}>
          <h2 className="accordion-header" id={`heading-${item.id}`}>
            <button data-interaction="faq_card_support_collapse"
              className={`accordion-button text-left ${activeAccordion === item.id ? "" : "collapsed"}`}
              type="button"
              onClick={() => toggleAccordion(item.id)}
              aria-expanded={activeAccordion === item.id}
              aria-controls={`collapse-${item.id}`}
       
            >
              {item.question}
            </button>
          </h2>
          <div
            id={`collapse-${item.id}`}
            className={`accordion-collapse collapse ${activeAccordion === item.id ? "show" : ""}`}
            aria-labelledby={`heading-${item.id}`}
            data-bs-parent={`#${parentId}`}
          >
            <div className="accordion-body text-left" >
              {Array.isArray(item.answer) ? (
                <ul>
                  {item.answer.map((answer, index) => (
                    <li
                      key={index}
                      style={
                        item.id === "item5" && index === 3
                          ? { marginBottom: "45px" }
                          : {}
                      }
                    >
                      {answer}
                    </li>
                  ))}
                </ul>
              ) : (
                // Rendering HTML directly when content is a string
                <div dangerouslySetInnerHTML={{ __html: item.answer }} />
              )}
            </div>
          </div>
        </div>
      ))}
    </div>
  );

  return (
    <div className="card custom-card">
      <div className="card-body">
        {activeTab === "general" && (
          <>
            <h5 className="text-center mb-3">General</h5>
            {renderAccordion(generalFAQs, "accordionFAQ1")}
          </>
        )}
        {activeTab === "support" && (
          <>
            <h5 className="text-center mb-3">Support</h5>
            {renderAccordion(supportFAQs, "accordionFAQ2")}
          </>
        )}
      </div>
    </div>
  );
};

export default Faqcardsupport;
